import i from"styled-components";import{theme as o}from"../../../theme.js";const r=i.div`
  position: relative;
  `,e=i.button`
  display: grid;
  grid-template-columns: 24px max-content;
  gap: ${o.spacing}px;
  align-items: center;
  position: relative;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  color: ${o.colors.primary[500]};
  background-color: unset;
  font-size: 14px;
  line-height: 24px;
  > svg {
    width: 24px;
    height: 24px;
    &.like {
      > g, path {
        fill: ${o.colors.primary[300]};
      }
    }
  }
`,n=i.div`
  display: flex;
  gap: ${o.spacing*2}px;
  align-items: center;
  box-shadow: ${o.boxShadow};
  border-radius: ${o.radius}px;
  padding: ${o.spacing}px;
  position: absolute;
  background-color: ${o.colors.shades[0]};
  top: -28px;
  > button {
    cursor: pointer;
    border: none;
    padding: 0;
    outline: unset;
    background-color: unset;
    cursor: pointer;
    > svg {
      width: 30px;
      height: 30px;
      &:hover {
        transform: scale(1.1);
        transition: all .1s ease-in-out;
      }
    }
  }

`;export{e as Button,r as Container,n as PopperContainer};
